import { Injectable, Injector, ApplicationRef, ComponentFactoryResolver } from '@angular/core';
import { SwMaskComponent } from './sw-mask.component';

@Injectable({
  providedIn: 'root'
})
export class SwMaskService {

  constructor(
    private injector: Injector,
    private applicationRef: ApplicationRef,
    private componentFactoryResolver: ComponentFactoryResolver
    ) { }

  SwMaskComponentRef:any;
  com:any
  //关闭加载框
  closeMask(){ 
    this.SwMaskComponentRef.instance.closeMask()
    document.body.removeChild(this.com);
    this.applicationRef.detachView(this.SwMaskComponentRef.hostView);
    this.SwMaskComponentRef.destroy()
  }
  //打开加载框
  openMask(tip?:string){ 

    this.com = document.createElement(SwMaskComponent.name);
    //创建动态组件
    const factory = this.componentFactoryResolver.resolveComponentFactory(SwMaskComponent);
    this.SwMaskComponentRef = factory.create(this.injector, [], this.com);
    this.applicationRef.attachView(this.SwMaskComponentRef.hostView);

    document.body.appendChild(this.com);
    this.SwMaskComponentRef.instance.tip = tip
    this.SwMaskComponentRef.instance.openMask()
  }
}
